const DEFAULT_ERROR_MAP = {
  access_denied: "Access denied",
};

export const formatApiErrorMessage = (message, { map = {} } = {}) => {
  if (!message || Array.isArray(message)) {
    return null;
  }

  if (typeof message === "object") {
    return Object.entries(message)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  }

  const resolved = { ...DEFAULT_ERROR_MAP, ...map }[message];
  return resolved || message;
};

export const throwApiError = (dataOrMessage, options = {}) => {
  const message =
    dataOrMessage &&
    typeof dataOrMessage === "object" &&
    !Array.isArray(dataOrMessage)
      ? dataOrMessage.message
      : dataOrMessage;

  const formatted = formatApiErrorMessage(message, options);
  if (formatted) {
    throw formatted;
  }
};
